<template>
  <b-button
    :title="$t('Visualizar e Imprimir')"
    :to="to"
    target="_blank"
    class="px-2 mb-0"
    size="xs"
    type="button"
    v-b-tooltip.hover
    variant="primary"
  >
    <i class="mdi mdi-eye" />
  </b-button>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      required: true
    }
  }
}
</script>